import { render, staticRenderFns } from "./ShowUserCode.vue?vue&type=template&id=3c5b50a4&"
import script from "./ShowUserCode.vue?vue&type=script&lang=js&"
export * from "./ShowUserCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports